import Repository from "./masterRepository";

const createOrder = "create";
const getPlan = "/billing/scope/get";
const updatePlan = "/billing/scope/update";
const getAllPlans = "/masters/plans/get";
const getModules = "/admin/modules/get";
const addBilling = "/billing/scope/add";

const getPaymentGateway = "/masters/paymentGateway/get";

export default {
  createOrder(payload) {
    return Repository.post(transformRoute1(createOrder), payload);
  },

  getPlan(payload) {
    return Repository.post(`${getPlan}`, payload);
  },
  updatePlan(payload) {
    return Repository.post(`${updatePlan}`, payload);
  },

  getModules(payload) {
    return Repository.post(`${getModules}`, payload);
  },
  addBilling(payload) {
    return Repository.post(`${addBilling}`, payload);
  },
  getAllPlans(payload) {
    return Repository.post(`${getAllPlans}`, payload);
  },

  getPaymentGateway(payload) {
    return Repository.post(`${getPaymentGateway}`, payload);
  },
};

const transformRoute1 = (route) => {
  return `/studio/orders/${route}`;
};
